import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  connect() {
    // This method is called when the controller is connected to the DOM
  }

  toggle() {
    this.menuTarget.classList.toggle("hidden")
  }
}
